import { handlePartnerFlowInitialData } from '@Services/init/flow-identifier-service/partner.service.ts';
import { handleAuthUserFlowInitialData } from '@Services/init/flow-identifier-service/authUserOnboarding.service.ts';
import { handleAccountantPortalFlowInit } from '@Services/init/flow-identifier-service/accountantPortalOnboarding.service.ts';
import { useBoundStore } from '@Store/useBoundStore';
import { OnboardingFlowIdentifier } from '@Types/onboarding.types';
import { handleUboFlowInitialData } from './uboOnboardingIdentifer.service';
import { handleDirectLoginFlowInitialData } from './directLogin.service';
import { handleCookieResumeFlow } from './cookieResume.service';

interface IParams {
  partnerToken: string;
  referralCode: string;
  customerKey: string;
  sourcePlatform: string;
  customerId: string;
  authorizedUserId: string;
  uboId: string;
  multiBusinessId: string;
  loginToken: string;
  continueMultiBusiness: boolean;
}

export const flowIdentifierService = async ({
  partnerToken,
  authorizedUserId,
  customerId,
  uboId,
  multiBusinessId,
  loginToken,
  continueMultiBusiness,
}: IParams) => {
  if (multiBusinessId) {
    const setOnboardingIdentifier =
      useBoundStore.getState().onboardingSlice.setOnboardingIdentifier;
    const setCustomerAccessToken = useBoundStore.getState().setCustomerAccessToken;
    if (partnerToken) {
      setCustomerAccessToken(partnerToken);
    }
    setOnboardingIdentifier(OnboardingFlowIdentifier.DIRECT_MULTI_BUSINESS);
  } else if (partnerToken) {
    await handlePartnerFlowInitialData(partnerToken);
  } else if (customerId && authorizedUserId) {
    const redirected = await handleAuthUserFlowInitialData(customerId, authorizedUserId);
    if (redirected) return true;
  } else if (authorizedUserId && !customerId) {
    handleAccountantPortalFlowInit(authorizedUserId);
  } else if (uboId) {
    await handleUboFlowInitialData(uboId);
  } else if (loginToken || continueMultiBusiness) {
    await handleDirectLoginFlowInitialData(loginToken, customerId, continueMultiBusiness);
  } else if (customerId) {
    // Cookie-authenticated resume: the webapp redirects a mid-onboarding user with only
    // `?id=<customerId>` and the session is in the HttpOnly onboardingToken cookie (LC-31318).
    await handleCookieResumeFlow(customerId);
  }
  return false;
};
